import { FC } from 'react'
import './adjust-ledger-nudge.css'

// COMPONENTS
import * as Icons from '@icons'
import Button from '@components/atoms/button'


export interface AdjustLedgerNudgeProps {
    isOrganizer: boolean
    groupType: "pending" | "fixed" | "open" | "both" | "merchant"
    onAdjustLedger: () => void
}

const AdjustLedgerNudge: FC<AdjustLedgerNudgeProps> = (props) => {
    const { onAdjustLedger, isOrganizer, groupType } = props

    return (
        <div className='adjust-ledger-nudge'>
            <div className="flex flex-row gap-4 items-start">
                <div className="bubble-xsml checkmark flex items-center justify-center" style={{ background: 'var(--splitcard-yellow-200)' }}>
                    <Icons.Clock width="1.5rem" height="1.5rem" tint="var(--splitcard-yellow-600)" />
                </div>
                <div className="flex flex-col gap-2.5 flex-1">
                    <p><strong>Action Needed: Review Splits</strong></p>
                    <p>The final total changed due to a tip or fee. Update how the cost is split so everyone pays the correct amount.</p>
                    {isOrganizer && groupType !== 'merchant' && <div className="flex flex-row gap-4">
                        <Button theme="primary" size="small" onClick={onAdjustLedger} style={{ background: 'var(--splitcard-yellow-600)', borderColor: 'var(--splitcard-yellow-600)' }}>Update Splits</Button>
                    </div>}
                </div>
            </div>
        </div>
    )
}

export default AdjustLedgerNudge
